//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ConfirmDialog from 'ui-kit/src/components/ConfirmDialog';

export default {
    data() {
        return {
            nu: {
                tyreMake: '',
                tyreSize: '',
            },
        };
    },

    methods: {
        async add(e) {
            e.values.push(this.nu[e.key]);

            await $.updateOne('enums', e);

            this.nu[e.key] = '';
        },
        async remove(e, value) {
            this.$q.dialog({
                component: ConfirmDialog,
                title: this.$t(`confirm.remove.title.enums.${e.key}`),
                message: this.$t(`confirm.remove.message.enums.${e.key}`),
                okLabel: 'Smazat',
                cancelLabel: 'Storno',
            }).onOk(async () => {
                e.values.splice(e.values.indexOf(value), 1);

                await $.updateOne('enums', e);
            });
        },
    },

    @cancellableFetch
    async mounted() {
        await $.fetchAllUpdated('enums');
    },
};
